module.exports = __webpack_public_path__ + "img/recruiters-icon-white.f306640f.svg";